import { ReactNode } from "react";
import { AioBoolean } from "../additional/aioBoolean";
import styles from "../aic.module.css";
import { AitRowGroupData } from "./functions/AitRowGroupData";
import { getBaseId } from "./functions/getBaseId";
import { AitLocationBodyRowGroup, SET_SPACE_AFTER } from "./functions/interface";
import { trGetPositionFromLocation } from "./functions/trGetPositionFromLocation";
import { useTableContext } from "./TableContextProvider";

interface AitRowGroupSpaceAfterProps {
  location: AitLocationBodyRowGroup;
}

/**
 * Toggle control for 'space after' setting on a row group.
 *
 * @template T - Row group payload type
 * @param props - Component props
 * @param props.location - The row group location
 */
export const AitRowGroupSpaceAfter = <T,>({ location }: AitRowGroupSpaceAfterProps): ReactNode => {
  const { state, dispatch } = useTableContext<T>();
  const id = getBaseId(location, state?.id);
  const thisRowGroup: AitRowGroupData<T> | undefined = trGetPositionFromLocation(
    state,
    location,
  ).data;

  return !state || !thisRowGroup ? null : (
    <div className={styles.aiwBodyRow}>
      <AioBoolean
        id={`${id}-spaceafter-group`}
        label="Space after group"
        value={
          thisRowGroup.spaceAfter ??
          // istanbul ignore next
          false
        }
        disabled={!state.editable}
        setValue={(bool) => {
          dispatch({
            operation: SET_SPACE_AFTER,
            location,
            bool,
          });
        }}
      />
    </div>
  );
};

AitRowGroupSpaceAfter.displayName = "AitRowGroupSpaceAfter";
